import { Link } from "react-router-dom";
import { AgingBarChart } from "@/components/charts/AgingBarChart";
import { PendingStatus } from "@/components/ui/pending-indicator";
import { cn } from "@/lib/utils";
import type { DeskGlanceAgingBuckets } from "@/shared/api/desk";
import { HomeMetricCard } from "./HomeMetricCard";

const EMPTY_AGING: DeskGlanceAgingBuckets = {
  current: "0",
  d1_30: "0",
  d31_60: "0",
  d61_90: "0",
  d90_plus: "0",
};

/** To-pay aging with Recharts + Show more — plan/50. */
export function PayAgingWidget(props: {
  companySlug: string;
  currencyCode: string;
  aging: DeskGlanceAgingBuckets | null | undefined;
  loading?: boolean;
  onCustomize?: () => void;
  className?: string;
}) {
  const { companySlug, currencyCode, aging, loading, className } = props;
  const data = aging ?? EMPTY_AGING;
  const hasAny = Object.values(data).some((v) => Number(v) > 0);

  if (loading && !aging) {
    return (
      <HomeMetricCard
        title="To pay aging"
        description="Open purchase orders by days past payment due"
        size="wide"
        className={cn(className)}
        onCustomize={props.onCustomize}
        compact={<PendingStatus>Loading aging…</PendingStatus>}
        expanded={<PendingStatus>Loading aging…</PendingStatus>}
      />
    );
  }

  return (
    <HomeMetricCard
      title="To pay aging"
      description="Open purchase orders by days past payment due"
      size="wide"
      className={cn(className)}
      onCustomize={props.onCustomize}
      actions={
        <Link
          to={`/c/${companySlug}/purchasing/to-pay`}
          className="shrink-0 text-xs font-medium text-[var(--color-primary)] no-underline hover:underline"
        >
          To pay
        </Link>
      }
      empty={!hasAny}
      emptyMessage="Nothing open to pay — bars show when PO balances age."
      compact={
        <AgingBarChart aging={data} currencyCode={currencyCode} compact />
      }
      expanded={
        <AgingBarChart aging={data} currencyCode={currencyCode} />
      }
    />
  );
}
